module.exports = require("is-mergeable-object");